import { render, staticRenderFns } from "./CheckItemsTab.vue?vue&type=template&id=13c689bf&scoped=true&"
import script from "./CheckItemsTab.vue?vue&type=script&lang=js&"
export * from "./CheckItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./CheckItemsTab.vue?vue&type=style&index=0&id=13c689bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c689bf",
  null
  
)

export default component.exports